import { Fetch } from '@home-diy-toolbox/web/fetch';

const fetch = new Fetch();

export default fetch;
